import error from './error';
import feature from './feature';
import settings from './settings';
import user from './user';
import { DEFAULT_LOCALE } from '../services/language-helpers';

export interface DefaultExchangeLinks {
  defaultBuyLink: string;
  defaultSellLink: string;
  defaultSwapLink: string;
}

interface RootState {
  lockCounter: number;
  serverTimeDiff: number | null;
  language: string;
  redirect: boolean;
  defaultExchangeLinks: DefaultExchangeLinks | null;
}

export default {
  modules: {
    error,
    feature,
    settings,
    user,
  },
  state: {
    lockCounter: 0,
    serverTimeDiff: null,
    language: DEFAULT_LOCALE,
    redirect: false,
    defaultExchangeLinks: null,
  } as RootState,
  getters: {
    isLocked: (state: RootState): boolean => state.lockCounter > 0,
    serverTimeDiff: (state: RootState): number | null => state.serverTimeDiff,
    language: (state: RootState): string => state.language,
    isDefaultLanguage: (state: RootState): boolean => state.language === DEFAULT_LOCALE,
    isRedirecting: (state: RootState): boolean => state.redirect,
    defaultExchangeLinks: (state: RootState): DefaultExchangeLinks | null => state.defaultExchangeLinks,
  },
  mutations: {
    setServerTimeDiff(state: RootState, payload: number): void {
      state.serverTimeDiff = payload;
    },
    lock(state: RootState): void {
      state.lockCounter++;
    },
    unlock(state: RootState): void {
      if (state.lockCounter === 0) {
        return;
      }

      state.lockCounter--;
    },
    clearLocks(state: RootState): void {
      state.lockCounter = 0;
    },
    language(state: RootState, payload: string): void {
      state.language = payload;
    },
    initRedirect(state: RootState): void {
      state.redirect = true;
    },
    destroyRedirect(state: RootState): void {
      state.redirect = false;
    },
    setDefaultExchangeLinks(state: RootState, payload: DefaultExchangeLinks): void {
      state.defaultExchangeLinks = payload;
    },
  },
};
